import { render } from "./AccountOrderDetailsShipmentInfo.vue?vue&type=template&id=01fd688c"
import script from "./AccountOrderDetailsShipmentInfo.vue?vue&type=script&lang=js"
export * from "./AccountOrderDetailsShipmentInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__